import { useEffect, useState } from 'react';
import apiClient from '../api/client';

const STORAGE_KEY = 'torgoslav_marketplace';

export function useClientMarketplaces(clientId) {
  const [caps, setCaps] = useState(null);
  const [marketplace, setMarketplace] = useState('wb');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) {
      setCaps(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setCaps(null);
    apiClient
      .get(`/clients/${clientId}/capabilities`)
      .then(({ data }) => {
        if (cancelled) return;
        setCaps(data);
        const stored = localStorage.getItem(`${STORAGE_KEY}_${clientId}`);
        const list = data?.marketplaces || [];
        if (stored && list.includes(stored)) {
          setMarketplace(stored);
        } else if (list.length) {
          setMarketplace(list[0]);
        }
      })
      .catch(async () => {
        if (cancelled) return;
        try {
          const { data: clients } = await apiClient.get('/clients');
          const client = Array.isArray(clients)
            ? clients.find((c) => String(c.id) === String(clientId))
            : null;
          if (client?.is_demo) {
            setCaps({
              wb: true,
              ozon: true,
              avito: true,
              avito_ads: true,
              marketplaces: ['wb', 'ozon', 'avito', 'avito_ads'],
              is_demo: true,
            });
            return;
          }
        } catch { /* ignore */ }
        setCaps({ marketplaces: ['wb'], wb: true, avito_ads: false, is_demo: false });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [clientId]);

  const changeMarketplace = (mp) => {
    setMarketplace(mp);
    if (clientId) localStorage.setItem(`${STORAGE_KEY}_${clientId}`, mp);
  };

  return { caps, marketplace, setMarketplace: changeMarketplace, loading };
}
